import { render, staticRenderFns } from "./ClassDetailModal.vue?vue&type=template&id=0e794395&scoped=true"
import script from "./ClassDetailModal.vue?vue&type=script&lang=js"
export * from "./ClassDetailModal.vue?vue&type=script&lang=js"
import style0 from "./ClassDetailModal.vue?vue&type=style&index=0&id=0e794395&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e794395",
  null
  
)

export default component.exports